module.exports = __webpack_public_path__ + "img/productIntroduction.7fcc6d4b.png";